import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { GlobalsPaths } from '../app.config';
import { ResetPasswordService } from '../_services/reset-password.service';
import { ToasterErrorService } from '../_services/toaster.service';

@Component({
  moduleId: module.id,
  selector: 'forgot-password-app',
  templateUrl: `./forgot-password.html`,
})

export class ForgotPasswordComponent {
  img: string = this.globalsPaths.img;
  toasterconfig: any = this.toasterErrorService.toasterconfig;
  disableSend: boolean = false;
  pageLoaded: boolean = false;
  emailForResetPass: string;

  constructor(private globalsPaths: GlobalsPaths,
              private resetPasswordService: ResetPasswordService,
              private toasterErrorService: ToasterErrorService,
              private router: Router) {}

  ngOnInit() {
    let that = this;

     setTimeout(function(){
      that.pageLoaded = true;
    }, 1000);
  }

  resetPassword(emailForResetPass: string) {
    this.disableSend = true;
    this.resetPasswordService.postResetPassword(emailForResetPass)
    .subscribe(
      successData => {
        this.disableSend = false;
        this.toasterErrorService.toasterSuccess(successData.message);
        setTimeout(() => {
          this.router.navigate(['/login']);
        }, 1500);
      },
      errData => {
        this.disableSend = false;
        let _errorBody = JSON.parse(errData._body);
        console.log('reset error: ', errData);
        this.toasterErrorService.toasterErr(_errorBody.message);
      }
    );
  }
}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/Forgot-password/forgot-password.component.ts